import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorBoundary } from 'react-error-boundary';
import { scan as reactScan } from 'react-scan';
import App from './App';
import { errorLogger, generateErrorPage } from './error-handling';

if (import.meta.env.VITE_REACT_SCAN === 'true') {
  reactScan({
    enabled: process.env.NODE_ENV === 'development',
    showToolbar: process.env.NODE_ENV === 'development',
    dangerouslyForceRunInProduction: false,
    log: false,
    animationSpeed: 'off',
    trackUnnecessaryRenders: process.env.NODE_ENV === 'development',
    showNotificationCount: false,
    showFPS: false
  });
}

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <ErrorBoundary fallbackRender={generateErrorPage} onError={errorLogger}>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
